export const selectJobsOrderSortObj = state => state.jobOrders.meta.sort
export const selectJobOrdersFilters = state =>
  (state &&
    state.jobOrders &&
    state.jobOrders.meta &&
    state.jobOrders.meta.filters) ||
  {}
